import { stats } from '@fiverr-private/obs';

const STATS_METRIC_PACKAGE_NAME = 'packages.categories_menu';

export const count = (metricName, incrementBy = 1) => {
    stats.count(STATS_METRIC_PACKAGE_NAME, metricName, incrementBy);
};
